<div bsModal [config]="UiConstants.modalConfig" #fieldDialog="bs-modal" (onHide)="onModalHide($event)"
     class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" *ngIf="visible">
      <div class="modal-header">
        <h4 class="modal-title">{{dialogTitleDictionaryKey | translate}}</h4>
        <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body p-0">

          <h6>{{'COMMON_BASIC_DATA' | translate}}</h6>

          <div class="row">

            <!-- region Title -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.TITLE) || hasLocalFieldError(title)}">
              <label>{{'COMMON_NAME' | translate}}</label>
              <input type="text" class="form-control" placeholder="{{'COMMON_NAME' | translate}}"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.TITLE) || hasLocalFieldError(title) }"
                     [(ngModel)]="fieldModel.title"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.TITLE)"
                     (blur)="onTitleBlur()"
                     name="title" id="title" #title="ngModel" required>
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.TITLE)">
                {{getFieldErrorText(Form.FieldValidatedField.TITLE)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError(title)">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
            <!-- endregion Title -->

            <!-- region field width - DISABLED -->
            <div class="form-group col-md-3">
              <label>{{'FORM_ITEM_COMMON_FIELD_WIDTH' | translate}}</label>
              <select class="form-control" [(ngModel)]="fieldModel.fieldWidthType"
                      id="fieldWidth" name="fieldWidth" #fieldWidth="ngModel"
                      [disabled]="true">
                <option *ngFor="let widthType of fieldWidthTypes" [ngValue]="widthType">{{widthType.textDictionaryKey | translate}}</option>
              </select>
            </div>
            <!-- endregion field width - DISABLED -->

          </div> <!-- ./row end -->

          <div class="row">

            <!-- region API export name -->
            <div class="form-group col-md-6" [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.API_EXPORT_NAME) || hasLocalFieldError(api_export_name) }">
              <label>{{'FORM_ITEM_COMMON_EXPORT_NAME' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="fieldModel.apiExportName" #api_export_name="ngModel"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.API_EXPORT_NAME) || hasLocalFieldError(api_export_name) }"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.API_EXPORT_NAME)"
                     placeholder="{{'FORM_ITEM_COMMON_EXPORT_NAME' | translate}}"
                     name="api_export_name" id="api_export_name"
                     required>
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.API_EXPORT_NAME)">
                {{getFieldErrorText(Form.FieldValidatedField.API_EXPORT_NAME)}}
              </div>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError(api_export_name)">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
            <!-- endregion API export name -->

            <!-- region PDF export name -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': hasFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME) }">
              <label>{{'FORM_ITEM_COMMON_PDF_EXPORT_NAME' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="fieldModel.pdfExportName"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     #pdfExportName="ngModel" name="pdfExportName" id="pdfExportName"
                     (ngModelChange)="removeFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME)"
                     placeholder="{{'FORM_ITEM_COMMON_PDF_EXPORT_NAME' | translate}}"
                     [ngClass]="{ 'form-control-danger': hasFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME) }">
              <div class="form-control-feedback" *ngIf="hasFieldError(Form.FieldValidatedField.PDF_EXPORT_NAME)">
                {{getFieldErrorText(Form.FieldValidatedField.PDF_EXPORT_NAME)}}
              </div>
            </div>
            <!-- endregion PDF export name -->

          </div> <!-- ./row end -->

          <div class="row">

            <!-- region Description -->
            <div class="form-group col-md-6">
              <label>{{'COMMON_DESCRIPTION' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="fieldModel.description" #description="ngModel"
                     maxlength="{{UiConstants.maximumVarcharLength}}"
                     placeholder="{{'COMMON_DESCRIPTION' | translate}}"
                     name="description" id="description">
            </div>
            <!-- endregion Description -->

          </div> <!-- ./row end -->

          <h6 class="mt-1">{{'FORM_ITEM_CREATE_DOCUMENT_EXTRA_DATA' | translate}}</h6>

          <div class="row">

            <!-- region file number -->
            <div class="form-group col-md-6">
              <label>{{'FORM_ITEM_CREATE_DOCUMENT_FILE_NUMBER' | translate}}</label>
              <mat-radio-group [required]="true" class="d-flex flex-row" [(ngModel)]="fieldModel.multiSelect">
                <mat-radio-button class="pl-0" [value]="false" [disableRipple]="true">{{'FORM_ITEM_CREATE_DOCUMENT_FILE_SINGLE' | translate}}</mat-radio-button>
                <mat-radio-button class="pl-1" [value]="true" [disableRipple]="true">{{'FORM_ITEM_CREATE_DOCUMENT_FILE_MULTIPLE' | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>
            <!-- endregion file number -->

            <!-- region file type -->
            <div class="form-group col-md-6"
                 [ngClass]="{ 'has-danger': fileTypeInvalid}">
              <label>{{'FORM_ITEM_CREATE_DOCUMENT_FILE_TYPE' | translate}}</label>
              <br>
              <mat-checkbox
                class="mr-1"
                [checked]="fieldModel.documentFileType === DocumentFileType.MEDIA || fieldModel.documentFileType === DocumentFileType.ANY"
                (click)="toggleDocumentFileType(DocumentFileType.MEDIA)">
                {{'FORM_ITEM_CREATE_DOCUMENT_FILE_TYPE_MEDIA' | translate}}
              </mat-checkbox>
              <mat-checkbox
                [checked]="fieldModel.documentFileType === DocumentFileType.DOCUMENT || fieldModel.documentFileType === DocumentFileType.ANY"
                (click)="toggleDocumentFileType(DocumentFileType.DOCUMENT)">
                {{'FORM_ITEM_CREATE_DOCUMENT_FILE_TYPE_DOCUMENT' | translate}}
              </mat-checkbox>
              <div class="form-control-feedback" *ngIf="fileTypeInvalid">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
            <!-- endregion file type -->

          </div> <!-- ./row end -->

            <div class="row">
              <div class="form-group col-md-12">
                <label class="">
                  {{ 'TRIGGER_FILE_NAME_PATTERN'|translate }}
                  <i class="icomoon icomoon-info info-icon"
                     popover="{{'FORM_ATTACHMENT_TRIGGER_FILENAME_PATTERN_HINT' | translate}}"
                     triggers="mouseenter:mouseleave" container="body" placement="right">
                  </i>
                </label>
                <app-material-tag-input
                  #fileNamePattern="ngModel" name="fileNamePattern" id="fileNamePattern"
                  [(ngModel)]="fieldModel.fileNamePattern"
                  [placeholderStringKey]="'TRIGGER_FILE_NAME_PATTERN'"
                  [autocompleteItems]="fileNamePatternOptions"
                  [separatorCharacter]="FormAttachmentFields.separatorCharacter"
                  [separatorKeyCodes]="FormAttachmentFields.separatorKeyCodes"
                  [shouldGenerateExample]="false">
                </app-material-tag-input>
              </div>
          </div> <!-- ./card-body end -->

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDialog()">{{'COMMON_BUTTON_CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" #functionButton (click)="saveField()">{{'COMMON_BUTTON_SAVE' |
          translate}}
        </button>
      </div>

    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

